import { render, staticRenderFns } from "./ba-list-pdf.vue?vue&type=template&id=18faceed&scoped=true&"
import script from "./ba-list-pdf.vue?vue&type=script&lang=js&"
export * from "./ba-list-pdf.vue?vue&type=script&lang=js&"
import style0 from "./ba-list-pdf.vue?vue&type=style&index=0&id=18faceed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18faceed",
  null
  
)

export default component.exports